import { render, staticRenderFns } from "./answeredPreview.vue?vue&type=template&id=caded6fa&scoped=true&"
import script from "./answeredPreview.vue?vue&type=script&lang=js&"
export * from "./answeredPreview.vue?vue&type=script&lang=js&"
import style0 from "./answeredPreview.vue?vue&type=style&index=0&id=caded6fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caded6fa",
  null
  
)

export default component.exports